export default __webpack_public_path__ + "static/media/Watered_Down_Logo.6d95c46e.png";